<template>
  <section>
    <container class="container">
      <h2 class="title">{{ title }}</h2>
      <ul class="content">
        <li class="persons"><span>Recept voor:</span> {{ persons }}</li>
        <li class="cookingTime"><span>Kooktijd:</span> {{ cookingTime }}</li>
        <li class="prepTime"><span>Voorbereidingstijd:</span> {{ prepTime }}</li>
      </ul>
      <div class="columns">
        <div class="left">
          <div class="video">
            <video @click="toggleVideo" width="100%" ref="video" :poster="`/image/recipe${id}.jpg`">
              <source :src="`/videos/recipe${id}.mp4`" type="video/mp4">
              Your browser does not support HTML video.
            </video>
            <button @click="toggleVideo" v-if="!playing" class="playButton">
              <img src="../assets/play.svg" alt="">
            </button>
          </div>
        </div>
        <div class="right">
          <div class="ingredients">
            <button-header>Ingrediënten {{ title }}</button-header>
            <cms-content v-html="ingredients" />
          </div>
        </div>
      </div>
      <div class="steps">
        <button-header>De stappen</button-header>
        <cms-content v-html="steps" />
      </div>
    </container>
  </section>
</template>
<script>
import Container from '../components/Container.vue';
import ButtonHeader from '../components/ButtonHeader.vue';
import CmsContent from '../components/CmsContent.vue';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    persons: {
      type: String,
      required: true,
    },
    cookingTime: {
      type: String,
      required: true,
    },
    prepTime: {
      type: String,
      required: true,
    },
    ingredients: {
      type: String,
      required: true,
    },
    steps: {
      type: String,
      required: true,
    },
  },
  components: {
    Container,
    ButtonHeader,
    CmsContent,
  },
  data() {
    return {
      playing: false,
    };
  },
  methods: {
    toggleVideo() {
      if (!this.playing) {
        this.$refs.video.play();
        this.playing = true;
      } else {
        this.$refs.video.pause();
        this.playing = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  text-align: left;
  @include tablet {
    text-align: center;
  }
}

h2.title {
  font-family: $national-condensed-bold;
  font-size: 25px;
  color: #000000;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  @include tablet {
    font-size: 30px;
  }
}

ul.content {
  padding: 0;
  margin: 0 0 50px 0;

  li {
    font-family: $national-condensed;
    list-style-type: none;
    font-size: 16px;
    color: #000000;
    line-height: 18px;
    @include tablet {
      font-size: 18px;
      line-height: 24px;
    }

    span {
      font-family: $national-condensed-bold;
      text-transform: uppercase;
    }

  }

}

.columns {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 50px;
  @include tablet {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
}

.video {
  width: 100%;
  margin: 0 0 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  video {
    cursor: pointer;
  }

}

.playButton {
  position: absolute;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}


.ingredients {
  text-align: left;
}
</style>
